export function publicApiBaseUrl(configured: string | undefined): string {
  const origin = configured?.trim().replace(/\/+$/, '');
  return origin ? `${origin}/api` : '/api';
}
